<template>
  <ModalInformation
    :show="show"
    @close="show = false"
    title="Login created"
    maxWidth="lg"
  >
    <template v-if="credentials">
      <ParagraphText color="text-gray-500"
        >Send these details to {{ credentials.name }}. The password is only
        shown once, so copy it before closing.</ParagraphText
      >

      <pre
        class="mt-4 whitespace-pre-wrap rounded-md bg-gray-50 p-4 font-mono text-sm text-gray-900 dark:bg-gray-900 dark:text-gray-100"
        >{{ message }}</pre
      >

      <div class="mt-4">
        <ButtonBase
          color="white"
          :leadingIcon="ClipboardCopyIcon"
          @click="copy"
          >{{ copied ? 'Copied' : 'Copy login details' }}</ButtonBase
        >
      </div>
    </template>
  </ModalInformation>
</template>

<script setup>
import ModalInformation from '@/Common/Overlays/Modals/ModalInformation.vue'
import ParagraphText from '@/Common/Text/ParagraphText.vue'
import ButtonBase from '@/Common/Elements/Buttons/ButtonBase.vue'
import { ClipboardCopyIcon } from '@heroicons/vue/solid'
import { usePage } from '@inertiajs/inertia-vue3'
import { computed, ref, watch } from 'vue'

const page = usePage()

const show = ref(false)
const copied = ref(false)

// Keep our own copy so the modal survives the flash being cleared on the next visit
const credentials = ref(null)

watch(
  () => page.props.value.flash?.credentials,
  (value) => {
    if (value) {
      credentials.value = value
      copied.value = false
      show.value = true
    }
  },
  { immediate: true }
)

const message = computed(() =>
  credentials.value
    ? [
        `Login: ${route('login')}`,
        `Email: ${credentials.value.email}`,
        `Password: ${credentials.value.password}`,
      ].join('\n')
    : ''
)

function copy() {
  try {
    navigator.clipboard
      .writeText(message.value)
      .then(() => (copied.value = true))
  } catch (e) {
    // Clipboard unavailable; the details are still visible to copy by hand
  }
}
</script>
